import radioGroup from '../radio/radio-group.vue'
radioGroup.install = function (vue) {
  vue.component(radioGroup.name, radioGroup)
}
export default radioGroup



// WEBPACK FOOTER //
// ./src/ui/components/radio-group/index.js